import { Logo } from "../site/Logo";
import { Seo } from "../site/Seo";

export const AuthShell = ({ title, children }) => (
  <div className="grid min-h-screen bg-[#F4F6F8] lg:grid-cols-2">
    <Seo title={title} description="Restricted administrator access." noindex />
    <div className="relative hidden bg-[#0B1220] p-12 text-white lg:flex lg:flex-col lg:justify-between">
      <Logo dark testId="admin-auth-logo" />
      <div>
        <p className="eyebrow !text-blue-300">Restricted area</p>
        <p className="mt-6 max-w-md font-display text-3xl font-semibold leading-tight tracking-tight">Administrative access for authorised Trusted Leap personnel only.</p>
      </div>
      <p className="text-xs text-slate-500">Access is logged. Unauthorised access is prohibited.</p>
    </div>
    <div className="flex items-center justify-center p-6">
      <div className="w-full max-w-sm">
        <div className="mb-10 lg:hidden"><Logo testId="admin-auth-logo-mobile" /></div>
        {children}
      </div>
    </div>
  </div>
);

export const PasswordRules = () => (
  <p className="text-xs text-slate-500">At least 12 characters, including letters and numbers.</p>
);

export const strongPassword = (v) => v.length >= 12 && /[A-Za-z]/.test(v) && /\d/.test(v);
